import { patchUrlMappings } from "@discord/embedded-app-sdk";
import { type FirebaseApp, initializeApp } from "firebase/app";
import { type Auth, getAuth } from "firebase/auth";
import { type Firestore, getFirestore } from "firebase/firestore";
import { loadEnv } from "../lib/env.js";

let app: FirebaseApp | undefined;
let auth: Auth | undefined;
let db: Firestore | undefined;
let patched = false;

function isInsideDiscordActivity(): boolean {
  if (typeof window === "undefined") return false;
  return (
    window.location.hostname.endsWith(".discordsays.com") ||
    new URLSearchParams(window.location.search).has("frame_id")
  );
}

export function getFirebase(): { app: FirebaseApp; auth: Auth; db: Firestore } {
  if (!app) {
    const env = loadEnv();
    if (!patched && isInsideDiscordActivity()) {
      patchUrlMappings([
        { target: "identitytoolkit.googleapis.com", prefix: "/firebase-auth" },
        { target: "securetoken.googleapis.com", prefix: "/firebase-token" },
        { target: "firestore.googleapis.com", prefix: "/firestore" },
      ]);
      patched = true;
    }
    app = initializeApp({
      apiKey: env.firebase.apiKey,
      authDomain: env.firebase.authDomain,
      projectId: env.firebase.projectId,
      appId: env.firebase.appId,
    });
    auth = getAuth(app);
    db = getFirestore(app);
  }
  return { app: app as FirebaseApp, auth: auth as Auth, db: db as Firestore };
}
